<template>
  <div class="main">
    <img src="@/assets/img/ing.png" alt="">
    <p>页面正在开发中 <span class="loading" /> </p>
  </div>
</template>
<script>

export default {
  name: 'Ing',
  data: () => {
    return {
    };
  }

};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.main{
  padding-top: 80px;
  text-align: center;
  font-size: 16px;
}
.loading:after {
    font-size: 20px;
    overflow: hidden;
    display: inline-block;
    vertical-align: bottom;
    animation: ellipsis 2s infinite;
    content: "\2026"; /* ascii code for the ellipsis character */
}
@keyframes ellipsis {
    from {
        width: 2px;
    }
    to {
        width: 20px;
    }
}
</style>
